import apiHelper from "../../../services/apiHelper";
import {Club, Member} from "../models/Member";
import {Plan} from "../../clubs/models/Plan";

export default {
  getCurrentMember: () => {
    return apiHelper.fetch('/me')
      .then(response => response.json())
      .then(data => {
        return new Member(data);
      });
  },
  getCurrentMemberClub: () => {
    return apiHelper.fetch('/my-club')
      .then(response => response.json())
      .then(data => {
        return new Club(data);
      });
  },
  getCurrentMemberClubPlans: () => {
    return apiHelper.fetch('/my-club-plans')
      .then(response => response.json())
      .then(data => {
        return Plan.fromArray(data);
      });
  }
}